import Button from '../ui/elements/button'
import LoadingDots from '../ui/shared/loading-dots'

export type PayingState = 'idle' | 'buying' | 'success' | 'error'

interface PayButtonsProps {
  onPay: () => void
  payDisabled: boolean
  payingState: PayingState
  payLabel: string
  onDismiss: () => void
}

export default function PayButtons({
  onPay,
  payDisabled,
  payingState,
  payLabel,
  onDismiss,
}: PayButtonsProps): JSX.Element {
  return (
    <div className="tw-flex tw-mt-5">
      {payingState !== 'success' ? (
        <Button
          size="large"
          disabled={payDisabled}
          action="primary"
          onClick={onPay}>
          {payingState === 'buying' ? <LoadingDots /> : payLabel}
        </Button>
      ) : (
        <Button size="large" action="success" onClick={onDismiss}>
          Close
        </Button>
      )}
    </div>
  )
}
